import { ConcreteEncodable } from "./ConcreteEncodable";

import { CreditRevalDetailsImplEncoder } from "../../encoder/CreditRevalDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { CreditRevalDetails } from "../CreditRevalDetails";

export class CreditRevalDetailsImpl extends ConcreteEncodable implements CreditRevalDetails {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.CreditRevalDetailsImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=901*/
  public lastCreditRevalTime: CubiqTS.Long | null = null;
  /*FID=902*/
  public lastCreditType: CubiqTS.CreditType;
  /*FID=903*/
  public lastCreditStatus: CubiqTS.CreditStatus;
  /*FID=904*/
  public lastCreditFailureReason: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CreditRevalDetailsImplEncoder.Instance;
    this.setEncodableType(CreditRevalDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CreditRevalDetailsImpl[" +
      "messageId=" +
      this.messageId +
      "lastCreditRevalTime=" +
      this.lastCreditRevalTime +
      "lastCreditType=" +
      this.lastCreditType +
      "lastCreditStatus=" +
      this.lastCreditStatus +
      "lastCreditFailureReason=" +
      this.lastCreditFailureReason +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
